/**
 * Cart upsell — the checkbox card for the product picked in Cart section
 * settings > Upsell. Checking it adds the product, unchecking removes it.
 *
 * The cart drawer replaces its own innerHTML whenever it refreshes, so the
 * change handler is delegated from `document` instead of bound to the input.
 * Afterwards the theme's own cart section instance re-fetches /cart, which
 * both redraws the drawer and re-binds its quantity/remove handlers.
 */
(function () {
	'use strict';

	function refreshCart() {
		var instances = (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) || [];

		var cartSection = instances.filter(function (instance) {
			return instance.type === 'cart';
		})[0];

		if (cartSection && typeof cartSection.getCart === 'function') {
			return cartSection.getCart();
		}

		// No cart section on this page (or it failed to load): fall back to a reload
		// so the customer still sees the updated cart.
		window.location.reload();
		return Promise.resolve();
	}

	function request(url, body) {
		return fetch(url, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: JSON.stringify(body)
		}).then(function (response) {
			if (!response.ok) {
				throw response;
			}
		});
	}

	function toggle(input) {
		var card = input.closest('.cart-upsell__product');
		var variantId = Number(input.dataset.variantId);
		var lineKey = input.dataset.lineKey;
		var checked = input.checked;

		var update = checked
			? request('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
			: request('/cart/change.js', { id: lineKey || String(variantId), quantity: 0 });

		input.disabled = true;
		card.classList.toggle('is-checked', checked);
		card.classList.add('is-loading');

		update
			.then(refreshCart)
			.catch(function () {
				input.checked = !checked;
				card.classList.toggle('is-checked', !checked);
			})
			.then(function () {
				input.disabled = false;
				card.classList.remove('is-loading');
			});
	}

	document.addEventListener('change', function (event) {
		var input = event.target.closest('[data-cart-upsell-toggle]');

		if (input) {
			toggle(input);
		}
	});
})();
